import React from "react";
import { Container } from "react-bootstrap";

function CoupkooReview() {
    return (
        <Container fluid className="project-section">
            <h1 className="project-heading"><strong className="cyan">Coupkoo Review</strong></h1>
            <p style={{ color: "white" }}>Content coming soon!</p>
        </Container>
    );
}

export default CoupkooReview;